var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseCircular = function SvgCloseCircular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440 78.1C341.6-22.2 177.9-24.5 77.6 73.9s-101.8 261.3-3.3 361.5c98.4 100.3 262.1 100.9 362.4 2.5S538.4 178.4 440 78.1M319.6 370.2l-63.4-64.5-68.2 66.9c-13.2 13-26.4 16.8-45.8-.6-19.2-19.8-16.3-36.1-3.1-49.1l68.2-67-66.9-68.1c-13-13.2-15.8-29.8 2.1-47.4 16.6-16.3 34.6-14.7 47.6-1.5L257 207l64.4-63.3c13.2-13 33-20 51.2-1.4 24.4 24.9 7.2 41.8-.5 49.3L306 256.8l63.4 64.5c13 13.2 18 35.4 1.3 51.1-17.4 16.4-38.1 11-51.1-2.2"
  })));
};
export default SvgCloseCircular;